import "../assets/qreader.css";
import { useCallback, useState, useEffect, useRef } from "react";
import { Dialog } from "@headlessui/react";
import { Scanner } from "@yudiel/react-qr-scanner";
import { axiosInstance } from "../utils/axios";
import { toast } from "react-toastify"; // Add toast for b
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import useDialogStore from "../stores/useDialogStore";

function DashboardQrCode() {
  const scannedRecentlyRef = useRef(false);
  const [scannerPaused, setScannerPaused] = useState(false);
  const isComponentMounted = useRef(true);
  const navigate = useNavigate();
  const { closeDialog } = useDialogStore();

  const deviceLookupMutation = useMutation({
    mutationFn: async (scannedId) => {
      const { data } = await axiosInstance.get(
        `${window.REACT_APP_API_ENDPOINT}/device/lookup?query=${scannedId}`
      );
      return data.data;
    },
    onSuccess: (deviceData) => {
      if (deviceData && deviceData.id) {
        navigate(`/devices/form/${deviceData.id}/edit`);
        setScannerPaused(true);
        closeDialog();
        scannedRecentlyRef.current = true;
        isComponentMounted.current = false;
      }
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || "Device not found");
      setScannerPaused(false);
      scannedRecentlyRef.current = false;
    },
  });

  const handleResult = useCallback(
    async (text, result) => {
      if (scannedRecentlyRef.current || !isComponentMounted) return;

      scannedRecentlyRef.current = true;
      if (!result) {
        toast.error("Invalid scan data");
        return;
      }

      const scannedIdValue = String(result).trim();
      console.log("scannedIdValue", scannedIdValue);
      deviceLookupMutation.mutate(scannedIdValue);
    },
    [isComponentMounted, deviceLookupMutation]
  );

  const handleError = useCallback(
    (error) => {
      if (isComponentMounted) {
        toast.error("Scanner error: " + error?.message, { autoClose: 3000 });
        console.error("Scanner error:", error);
      }
    },
    [isComponentMounted]
  );

  return (
    <div className="qreaderr">
      <Dialog.Title className="text-sm font-medium text-gray-900 mb-4">
        Please Scan the Device QR Code to Edit the Device
      </Dialog.Title>

      <Scanner
        onResult={handleResult}
        onError={handleError}
        constraints={{
          facingMode: "environment",
        }}
        paused={scannerPaused}
        className="w-full aspect-square"
      />

      <div className="mt-4 text-sm text-gray-500">
        Please align the QR code within the scanner frame
      </div>
    </div>
  );
}

export default DashboardQrCode;
